module.exports = __webpack_public_path__ + "static/media/incident_category-terrorism.60c4f6a5.svg";